<template>
  <div>
    <a-card :bordered="false" class="table_card">
      <div class="main_mnjy">
        <div class="main_jy">
          <div  style="margin-bottom: 40px">
            <div style="margin: 0 10px 0 40px">
              <span>{{ phone }}</span>
              <a-button type="primary" size="small" style="margin: 0 10px 0 20px"
                @click="addClick(clientId)" >新建策略</a-button>
              <a-button type="primary" size="small" @click="Refresh"> 刷新 </a-button>
              <a-button type="primary" size="small" style="margin: 0 0px 0 10px" @click="setClick(clientId)">
                设置
              </a-button>
            </div>
            <p style="margin: 10px 10px 20px 40px; width: 290px; height: 1px; background: #ccc"></p>
            <ul>
              <li v-for="(p, index) in strategyList" :key="index">
                <a-button :type="active == p.accountId ? 'primary' : ''" block @click="activeClick(p, index)"
                  style="text-align: left">
                  {{ p.tacticsName }} {{ p.tacticsType == 2 ? '[激进策略]' : p.tacticsType == 3 ? '[稳健策略]' : '' }}
                </a-button>
                <a @click="compileClick(p, clientId)">编辑</a>
                <!-- <a-popconfirm  title="您是否确定要删除本账号，删除后相关全部交易数据将被清空?" ok-text="确定"
                  cancel-text="取消" @confirm="confirm(p)" @cancel="cancel">
                  <a href="#" >{{p.upperLowerShelves==1?'上架':'下架'}}</a>
                </a-popconfirm> -->
                <a @click="upDownCLick(p)" v-if="isUpDown==1">{{ p.upperLowerShelves == 1 ? '上架' : '下架' }}</a>
              </li>

              <!-- <li>
             
            </li> -->
            </ul>
          </div>
          <!-- <a-button style="margin: 0px 0 0 40px; width: 280px" @click="bdClick()" v-if="list.length==0"> + &nbsp;绑定APP账号 </a-button> -->
        </div>
        <div v-if="active != ''">
          <MyIframe :info="info" :key="menuKey"></MyIframe>
        </div>
      </div>
    </a-card>
    <a-modal :title="IsCode == 1 ? '绑定APP账号' : '绑定APP策略'" :visible="bdvisible" :width="Appwidth" :maskClosable="false"
      :confirm-loading="confirmLoading" @ok="phoneCodeOk" @cancel="bdvisible = false">
      <div slot="footer" style="text-align: left; padding-left: 20px">
        <a-button type="primary" @click="phoneCodeOk(IsCode)">确定</a-button>
      </div>
      <div v-if="IsCode == 1">
        <a-row>
          <a-col :span="24">
            <a-form-item label="手机号" :label-col="{ span: 5 }" :wrapper-col="{ span: 17 }">
              <a-input v-model="phone" placeholder="请输入手机号" />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="15">
            <a-form-item label="验证码" :label-col="{ span: 8 }" :wrapper-col="{ span: 15 }">
              <a-input v-model="phoneCode" placeholder="请输入验证码" />
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item style="text-align: right;"><a-button type="primary" @click="getCode"> {{ text }} </a-button></a-form-item>
          </a-col>
        </a-row>
      </div>
      <div v-else-if="IsCode == 2" style="border: 1px solid #efefef; border-bottom: 0; margin-bottom: 15px">
        <a-table rowKey="id" :columns="columns" :dataSource="Tradelist" :pagination="false"> </a-table>
      </div>
    </a-modal>
    <a-modal :title="title" :visible="visible" width="700px" :maskClosable="false" :confirm-loading="confirmLoading"
      @ok="handleOk" @cancel="handleCancel">
      <a-form :form="form" style="height: auto">
        <a-row>
          <a-col :span="12">
            <a-form-item label="账号名称" :label-col="{ span: 8 }" :wrapper-col="{ span: 14 }">
              <a-input placeholder="请输入账号名称" v-model="form.tacticsName" v-decorator="[
                'tacticsName',
                { rules: [{ required: true, max: 10, message: '请输入10位以下的账号名称!' }] },
              ]" />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="可订阅量" :label-col="{ span: 8 }" :wrapper-col="{ span: 14 }">
              <a-input placeholder="请输入可订阅量" type="number" v-decorator="[
                'maxSubscriptionNum',
                { rules: [{ required: true, max: 10, pattern: /^[1-9]\d{0,8}$/, message: '请输入可订阅量!' }] },
              ]" />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="12">
            <a-form-item label="账号类型" :label-col="{ span: 8 }" :wrapper-col="{ span: 15 }">
              <a-select placeholder="请选择账号类型"
                v-decorator="['tacticsType', { rules: [{ required: true, message: '请选择账号类型!' }] }]">
                <!-- <a-select-option value="1">量化</a-select-option> -->
                <a-select-option value="2">激进策略</a-select-option>
                <a-select-option value="3">稳健策略</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="初始资金" :label-col="{ span: 8 }" :wrapper-col="{ span: 15 }">
              <a-select placeholder="请选择初始资金" :disabled="isShow"
                v-decorator="['styleId', { rules: [{ required: true, message: '请选择初始资金!' }] }]">
                <a-select-option v-for="(item, i) in styleList" :key="i" :value="item.id">{{
                  item.initMoney
                }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="12">
            <a-form-item label="管理人" :label-col="{ span: 8 }" :wrapper-col="{ span: 14 }">
              <a-input placeholder="请输入管理人"
                v-decorator="['belongTeacher', { rules: [{ required: true, message: '请输入管理人!' }] }]" />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="执业证书" :label-col="{ span: 8 }" :wrapper-col="{ span: 14 }">
              <a-input placeholder="请输入执业证书" v-decorator="[
                'certificateNum',
                { rules: [{ required: false, max: 25, message: '请输入正确的执业证书!' }] },
              ]" />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-form-item label="账号介绍" :label-col="{ span: 4 }" :wrapper-col="{ span: 19 }">
            <a-textarea placeholder="请输入账号介绍" :rows="4" style="resize: none" :maxLength="200" v-decorator="[
              'introduce',
              { rules: [{ required: true, max: 200, message: '请输入账号介绍，字数限制在200字之内！' }] },
            ]" />
          </a-form-item>
        </a-row>
        <a-row>
          <a-form-item label="交易规则" :label-col="{ span: 4 }" :wrapper-col="{ span: 19 }">
            <a-textarea placeholder="请输入交易规则" :rows="4" style="resize: none" v-decorator="[
              'tradingRules',
              { rules: [{ required: true, message: '请输入交易规则!' }] },
            ]" />
          </a-form-item>
        </a-row>
        <!-- <a-row>
          <a-form-item label="头像" :label-col="{ span: 4 }" :wrapper-col="{ span: 12 }">
            <a-upload name="upload" listType="picture-card" class="avatar-uploader" :showUploadList="false"
              :action="this.$uploadurl.uploadurl" :beforeUpload="beforeUpload" @change="handleChange"
              v-decorator="['avatar', { rules: [{ required: true, message: '请上传头像!' }] }]">
              <img v-if="form.avatar" width="100%" :src="form.avatar" alt="avatar" />
              <div v-else>
                <a-icon :type="loading ? 'loading' : 'plus'" />
                <div class="ant-upload-text">上传头像</div>
              </div>
            </a-upload>
          </a-form-item>
        </a-row> -->
        <!-- <div style="padding-left: 10%">
        <VueUeditorWrap  v-model="bigContent"
                         :config="editorConfig" />
      </div> -->
      </a-form>
    </a-modal>
    <a-modal title="设置" :visible="setvisible" @cancel="setvisible = false" :width="600" :maskClosable="false"
      :confirm-loading="confirmLoading">
      <div slot="footer">
        <a-button type="primary" @click="ydCodeOk">确定</a-button>
      </div>
      <div>
        <div style="border: 1px solid #efefef; border-bottom: 0; margin-bottom: 15px">
          <a-table rowKey="id" :columns="setcolumns" :dataSource="Tradelist" :pagination="false">
            <div slot="action" slot-scope="text, record, index">
              <a @click="upRecord(Tradelist, record, index)">上移</a>

              <a-divider type="vertical" />

              <a @click="downRecord(Tradelist, record, index)">下移</a>
            </div>
          </a-table>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import api from '@/api/trading'
import indexapi from '@/api/index'
import zfxfApi from '@/api/trading_zfxf'
import tradingAdd from '@/api/tradingAdd'
import { mapGetters } from 'vuex'
import { mobile_rule } from '@/utils/num'
import MyIframe from '@/components/iframe/iframe.vue'
let webkey = process.env.VUE_APP_APPKEY_URL
//  import VueUeditorWrap from 'vue-ueditor-wrap'
var columns = [
  {
    title: '类型',
    dataIndex: 'tacticsMsg',
  },

  {
    title: '策略名称',
    dataIndex: 'tacticsName',
  },
]
var setcolumns = [
  {
    title: '类型',
    dataIndex: 'tacticsMsg',
  },
  {
    title: '策略名称',
    dataIndex: 'tacticsName',
  },
  {
    title: '操作',
    dataIndex: 'action',

    scopedSlots: { customRender: 'action' },
  },
]
export default {
  components: { MyIframe },
  data() {
    return {
      visible: false,
      loading: false,
      model: {},
      active: '',
      form: this.$form.createForm(this),
      confirmLoading: false,
      styleList: [],
      list: [],
      Appwidth: 400,
      clientId: '',
      warntext: '',
      IsCode: 1,
      phone: sessionStorage.getItem('phone'),
      phoneCode: '',
      columns: columns,
      setcolumns: setcolumns,
      menuKey: 0,
      Tradelist: [],
      title: '',
      webkey: webkey,
      text: '获取验证码',
      info: {},
      isShow: false,
      isTypeShow: false,
      userId: '',
      accountId: '',
      bdvisible: false,
      setvisible: false,
      accounts: [],
      count: 0,
      isUpDown: sessionStorage.getItem('isUpDown'),
      showTypes: [],
      strategyList: [],
      clientId:sessionStorage.getItem('clientId'),
      sign:
        'w4ZcwpnCpixvwqLDgMKEw5jCrW%2FCgWFOOG51w4BERsOUDiDCqGAF5aS15bOQwrbDg8OZwpjCpAMAwodmw6vCjMKqRV1oCFjDvcKiwoBwwrcHM8Ojwq7DrDBkUsOcw6loQlnDqsKxEGvCkCzCkMOZaMKGwrBMw5zDt2fDpcKHw6HCkSpHB8KjwqLCocOrwrolw4XDpcK1w7PCksKvTcKccmvCt3DDrMK9wprChMKQw4FUw688FsKhJMKVdjvDgw%3D%3D',
    }
  },
  computed: {
    ...mapGetters(['nickname', 'avatar', 'type', 'adviserId']),
  },
  created() {
    // this.getList()
    // this.getStyleList()
    this.sysusersigin()
  },
  methods: {

    activeClick(item, i) {
      console.log(item)
      this.active = item.accountId

      this.info = item
      ++this.menuKey
      // document.getElementById('iframe').contentWindow.location.reload('http://192.168.2.196:8081/#/index?accountId=' + this.accountId+'&webkey=YR177354519450001' );
      // this.clientId=
    },
    sysusersigin() {
      // zfxfApi.sysusersigin({ "password": "e10adc3949ba59abbe56e057f20f883e", "username": "10298888" }).then((res) => {
      //   console.log(res)
      //   if (res.code == 200) {
      //     localStorage.setItem("Access-Token", res.data.token);
          this.getList()
          this.getStyleList()
      //   } else {
      //     this.$message.error(res.message)
      //   }
      // })
    },
    Refresh() {
      this.getList()
    },
    strategyPoolList() {
      tradingAdd.strategyPoolList({clientId:this.clientId}).then(res => {

        this.list.forEach(p => {
          // p.accounts.forEach(p => {

            res.data.forEach(item => {
              if (p.accountId == item.strategy_id) {
                p.upperLowerShelves = item.upper_lower_shelves

              }
            })

          // })

        })
        console.log(this.list, 5445654)
        this.strategyList = this.list
      })
    },
    compileClick(item, userId) {
      // console.log(item)
      this.userId = userId
      this.accountId = item.accountId
      this.isShow = true
      api.getTradeFindTactics({ accountId: item.accountId,clientId:this.clientId }).then((res) => {
        if (res.code == 200) {
          this.isTypeShow = true
          this.form.resetFields()
          this.model = Object.assign({}, res.data)
          console.log(this.model)
          this.title = '账号编辑'
          this.visible = true
          tradingAdd.tradingRules({ accountId: item.accountId,clientId:this.clientId }).then((data) => {
            console.log(res)
            this.form.avatar = this.model.picture
            this.$nextTick(() => {
              this.form.setFieldsValue({
                tacticsName: this.model.tacticsName,
                tacticsType: this.model.tacticsType,
                avatar: this.model.picture,
                styleId: this.model.styleId,
                belongTeacher: this.model.belongTeacher,
                certificateNum: this.model.certificateNum,
                introduce: this.model.introduce,
                tradingRules: data.data.tradingRules,
                maxSubscriptionNum: this.model.maxSubscriptionNum,
              })
            })
          })

        } else {
          this.$message.error(res.message)
        }
      })
      // resetFields()
      // this.model = Object.assign({}, item)

      // console.log(this.from)
      // console.log(this.model)
      // this.form.setFieldsValue({
      //   tacticsName: values.tacticsName,
      //   tacticsType: values.tacticsName,
      //   avatar: _this.form.avatar,
      //   styleId: values.styleId,
      //   belongTeacher: values.belongTeacher,
      //   certificateNum: values.certificateNum,
      //   introduce: values.introduce,
      //   maxSubscriptionNum: values.maxSubscriptionNum,
      // })
      //编辑页面禁止修改角色编码
      // if(this.model.id){
      //   this.roleDisabled = true;
      // }else{
      //   this.roleDisabled = false;
      // }
    },
    upRecord(arr, item, index) {
      if (index == 0) {
        return
      }
      var list = this.swapItems(arr, index, index - 1)
      console.log(list)
      var showTypes = []
      var accounts = []
      list.forEach((p) => {
        accounts.push(p.accountId)
        showTypes.push(p.showType)
      })
      this.accounts = accounts
      this.showTypes = showTypes
    },
    upDownCLick(p) {
      console.log(p)
      var upperLowerShelves = p.upperLowerShelves == 2 ? 1 : 2

      tradingAdd.upperLowerShelves({ accountId: p.accountId, upperLowerShelves: upperLowerShelves,clientId:this.clientId }).then(res => {
        this.getSXList()
      })
    },
    downRecord(arr, item, index) {
      //下移
      if (index == arr.length - 1) {
        return
      }
      var list = this.swapItems(arr, index, index + 1)
      var showTypes = []
      var accounts = []
      list.forEach((p) => {
        accounts.push(p.accountId)
        showTypes.push(p.showType)
      })
      this.accounts = accounts
      this.showTypes = showTypes
    },
    ydCodeOk() {
      if (this.accounts.length == 0) {
        return false
      }

      indexapi.getTradeMove({ accounts: this.accounts, showTypes: this.showTypes,clientId:this.clientId }).then((res) => {
        console.log(res)
        if (res.code == 200) {
          this.setvisible = false
          this.getSXList()
        } else {
          this.$message.error(res.message)
        }
      })
    },
    swapItems(arr, index1, index2) {
      //交换元素 --//数组,元素1，元素2
      arr[index1] = arr.splice(index2, 1, arr[index1])[0]
      return arr
    },
    bdClick() {
      this.phone = ''
      this.phoneCode = ''
      this.bdvisible = true
      this.IsCode = 1
      clearInterval(this.timer)
      this.text = '获取验证码'
      this.timer = null
    },
    phoneCodeOk(IsCode) {
      if (IsCode == 1) {
        var params = {
          phone: this.phone,
          code: this.phoneCode,
        }
        zfxfApi.getBindAccount(params).then((res) => {
          if (res.code == 200) {
            this.phone = ''
            this.phoneCode = ''
            this.Appwidth = 500
            this.$message.success('绑定成功')
            this.getTradeList(res.data.userId)
            this.getSXList()
          } else {
            this.$message.error(res.message)
          }
        })
      } else {
        // let list = []
        // this.Tradelist.forEach((p) => {
        //   list.push(p.accountId)
        // })
        // console.log(list)
        // zfxfApi.getBindAccount({ accountids: list }).then((res) => {
        //   if (res.code == 200) {
        this.IsCode = 1
        this.bdvisible = false
        this.Appwidth = 400

        //   } else {
        //     this.$message.error(res.message)
        //   }
        // })
      }
    },
    getCode() {
      const TIME_COUNT = 60
      if (this.phone == '') {
        this.$message.error('手机号不能为空')
        return false
      }
      if (!mobile_rule(this.phone)) {
        this.$message.error('手机号不正确')
        return false
      }
      var params = {
        phone: this.phone,
      }

      zfxfApi.getCode(params).then((res) => {
        if (res.code == 200) {
          if (!this.timer) {
            this.count = TIME_COUNT
            this.text = this.count + 's后可重发'
            //  this.show = false;
            this.isCodeTime = 1
            this.timer = setInterval(() => {
              if (this.count > 1 && this.count <= TIME_COUNT) {
                this.count--
                this.text = this.count + 's后可重发'
              } else {
                //  this.show = true;
                this.isCodeTime = 0
                clearInterval(this.timer)
                this.text = '获取验证码'
                this.timer = null
              }
            }, 1000)
          }
        } else {
          this.$message.success(res.message)
        }
      })
    },
    confirm(item) {
      // if
      api.getTradeDel({ accountId: item.accountId }).then((res) => {
        if (res.code == 200) {
          this.getList()
          this.$message.success('删除成功')
        }
      })
    },
    cancel() {
      this.$message.error('取消删除')
    },
    addClick(userId) {
      this.userId = userId
      console.log(userId)
      this.title = '账号新建'
      this.isShow = false
      this.isTypeShow = false
      this.visible = true
    },
    setClick(userId) {
      this.setvisible = true
      this.accounts = []
      this.showTypes = []
      this.userId = userId
      this.getTradeList(userId)
    },
    handleOk() {
      const _this = this
      this.form.validateFields((err, values) => {
        if (!err) {
          console.log('Received values of form: ', values)
          values.tacticsName = values.tacticsName.replace(/\s+/g, '')
          values.belongTeacher = values.belongTeacher.replace(/\s+/g, '')
          if (values.tacticsName == '') {
            _this.$message.error('账号名称不能为空')
            return
          }
          if (values.belongTeacher == '') {
            _this.$message.error('管理人不能为空')
            return
          }

          if (_this.title == '账号新建') {
            // return
            let params = {
             clientId:_this.clientId,
              tacticsName: values.tacticsName,
              tacticsType: values.tacticsType,
              picture: _this.form.avatar,
              styleId: values.styleId,
              belongTeacher: values.belongTeacher,
              certificateNum: values.certificateNum,
              introduce: values.introduce,
              tradingRules: values.tradingRules,
              maxSubscriptionNum: values.maxSubscriptionNum,
            }
            console.log(params)
            tradingAdd.createOrUpdate(params).then((res) => {
              console.log(res)
              if (res.code == 0) {
                _this.form.resetFields()
                _this.form.avatar = ''
                _this.visible = false
                _this.getSXList()
              } else {
                _this.$message.error(res.msg)
              }
            })
          } else {
            let params = {
              accountId: _this.accountId,
              gnStrategyId: _this.accountId,
             clientId:_this.clientId,
              tacticsName: values.tacticsName,
              tacticsType: values.tacticsType,
              picture: _this.form.avatar,
              belongTeacher: values.belongTeacher,
              certificateNum: values.certificateNum,
              introduce: values.introduce,
              styleId: values.styleId,
              tradingRules: values.tradingRules,
              maxSubscriptionNum: values.maxSubscriptionNum,
            }
            console.log(params)
            tradingAdd.createOrUpdate(params).then((res) => {
              console.log(res)
              if (res.code == 0) {
                _this.form.resetFields()
                _this.form.avatar = ''
                _this.visible = false
                _this.getSXList()
              } else {
                _this.$message.error(res.msg)
              }
            })
          }
        }
      })
    },
    handleCancel() {
      this.visible = false
      this.form.resetFields()
      this.form.avatar = ''
    },
    getStyleList() {
      api.getStockstyle({}).then((res) => {
        console.log(res)
        if (res.code == 200) {
          this.styleList = res.data
        }
      })
    },
    beforeUpload(file) {
      const isJPG =
        file.type === 'image/jpeg' ||
        file.type === 'image/png' ||
        file.type === 'image/gif' ||
        file.type === 'image/jpg' ||
        file.type === 'image/bmp'
      if (!isJPG) {
        this.$message.error('You can only upload jpg、gif、bmp、png、jpeg file!')
      }
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isLt2M) {
        this.$message.error('Image must smaller than 2MB!')
      }
      return isJPG && isLt2M
    },
    handleChange(info) {
      if (info.file.status === 'uploading') {
        this.loading = true
        return
      }
      if (info.file.status === 'done') {
        if ((info.file.response.code = 200)) {
          this.form.avatar = info.file.response.url
          this.loading = false
        } else {
          this.$message.error(info.file.response.message)
        }
      }
    },
    getTradeList(userId) {
      let params = {  clientId:this.clientId, appkey: this.webkey }
      zfxfApi.getTradeAccounts(params).then((res) => {
        console.log(res)
        if (res.code == 0) {
          this.Tradelist = res.data
          if (this.Tradelist.length == 0 && this.bdvisible == true) {
            this.IsCode = 1
            this.bdvisible = false
          } else if (this.bdvisible == true) {
            this.IsCode = 2
          }
          // this.sign=
        }
      })
    },
    getSXList() {
      let params = { clientId:this.clientId}
      zfxfApi.getTradeAccounts(params).then((res) => {
        console.log(res)
        if (res.code == 0) {
          this.list = res.data

          this.strategyPoolList()


          ++this.menuKey
          // this.sign=
        }
      })
    },
    getList() {
      let params = { clientId:this.clientId,}
      zfxfApi.getTradeAccounts(params).then((res) => {
        console.log(res,695)
        if (res.code == 0) {
          this.list = res.data
          // console.log(this.list.length, this.active)
          if (this.list[0]) {
            this.active = this.list[0].accountId
            this.info = this.list[0]


          //   console.log(this.info)
            ++this.menuKey
          }
          this.strategyPoolList()
          // this.sign=
        }
      })
    },
  },
}
</script>

<style lang="less" scoped>
.table_card {
  height: calc(100vh);
  overflow: auto;
}

.main_mnjy {
  display: flex;
}

.main_jy {
  // display: flex;
  // border: 1px solid #efefef;
  height: calc(100vh - 60px);
  width: 400px;
  margin-right: 150px;
  overflow: auto;

  ul {
    width: 330px;
    margin-left: 40px;
    // height:calc(100vw - 100px) ;
    // overflow-x: auto;
    margin-right: 200px;

    li {
      width: 300px;
      margin-bottom: 11px;
      list-style: none;
      display: flex;
      align-items: center;

      button {
        width: 200px;
      }

      a {
        display: flex;
        width: 30px;
        margin: 0 0 0 10px;
      }
    }
  }
}

/deep/.ant-modal-body {
  padding: 24px 24px 24px 0;
}

/deep/.ant-select-disabled .ant-select-selection {
  padding: 4px 14px;
  width: 192px;
}
</style>